module.exports = __webpack_public_path__ + "img/Google voice Icon - white.5abad2e7.svg";